import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ConfirmModalComponent } from './components/confirm-modal/confirm-modal.component';
import { ModalContainerComponent } from './components/modal-container/modal-container.component';
import { ModalService } from './services/modal.service';

@NgModule({
  imports: [CommonModule],
  declarations: [ModalContainerComponent, ConfirmModalComponent],
  providers: [ModalService]
})
export class ModalModule {}
